import React, { use, useEffect, useState } from "react";
import AudioControl from "./components/AudioControl";
import TunicIdeogram from "./components/TunicIdeogram";
import Settings from "./components/Settings";


export interface Config {
    color: string
    backgroundColor: string
    strokeSize: string
    glyphWidth: number
    glyphHeight: number
}

export default function App() {

    let [spokenWord, setSpokenWord] = useState("")
    let [config, setConfig] = useState<Config>({
        color: "#000000",
        backgroundColor: "trasparent",
        strokeSize: "1px",
        glyphHeight: 73,
        glyphWidth: 38
    })

    return (<>
        <h1>Speak-to-<span className="highlight" title="Tunic in-game text">Trunic</span></h1>
        <div>
            Phonemes may not be alligned with the correct translation
        </div>
        <Settings config={config} updateConfig={setConfig} />

        <AudioControl transcriptoutput={setSpokenWord} />
        <TunicIdeogram transcript={spokenWord} config={config} />
        <div>
            Thank you Andrew/Finji for this amazing game ❤️
        </div>

    </>);
};